import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Payment from "apps/payment/components/Payment";

import {
	setProduct,
	close,
	navigateScreen,
	getUserState,
	confirmPurchaseStoredInfo,
	fetchProductId,
	confirmPurchasePaypal,
	setErrorMessage,
	savePaypalInfo,
	fetchPaypalLink,
} from "ducks/payment";

export const mapStateToProps = (state) => {
	const { payment } = state;

	return payment;
};

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			savePaypalInfo,
			setErrorMessage,
			navigateScreen,
			setProduct,
			confirmPurchaseStoredInfo,
			getUserState,
			close,
			fetchProductId,
			confirmPurchasePaypal,
			fetchPaypalLink,
		},
		dispatch,
	);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(Payment);



// WEBPACK FOOTER //
// ./src/apps/payment/containers/Payment/index.jsx